import { render, staticRenderFns } from "./Study-detail.vue?vue&type=template&id=628a0404&scoped=true&"
import script from "./Study-detail.vue?vue&type=script&lang=js&"
export * from "./Study-detail.vue?vue&type=script&lang=js&"
import style0 from "./Study-detail.vue?vue&type=style&index=0&id=628a0404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628a0404",
  null
  
)

export default component.exports